export const UPDATE_MODEL_EVENT = 'update:modelValue'

export const CHANGE_EVENT = 'change'
export const INPUT_EVENT = 'input'

export const VALIDATE_STATE_MAP = {
  validating: 'el-icon-loading',
  success: 'el-icon-circle-check',
  error: 'el-icon-circle-close',
}
